module.exports = parcelRequire.resolve("6hp9H");